import {inject, Injectable, signal} from '@angular/core';
import {BehaviorSubject, catchError, Observable} from 'rxjs';
import {User} from '@auth0/auth0-angular';
import {CommunicationService} from '../http/communication.service';
import {AuthorizationService} from './authorization.service';
import {Permissions} from '../shared/permissions';
import {StorageService} from './storage.service';
import {LocalStorageKeys} from '../shared/types/storage';

@Injectable({
  providedIn: 'root',
})

export class StateService {
  private communicationService = inject(CommunicationService);
  private authorizationService = inject(AuthorizationService);
  private storageService = inject(StorageService);
  public isRouterOutletScrolledToTop = signal<boolean>(true);
  private loadingTriggersCountSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private _accounts: string[] = [];
  private _activeAccount = signal<string>(this.storageService.local.getItem(LocalStorageKeys.ACCOUNT) || '');

  readonly activeAccount = this._activeAccount.asReadonly();
  loading$ = this.loadingSubject.asObservable();

  constructor() {
    this.loadingTriggersCountSubject.subscribe(count => {
      this.loadingSubject.next(count > 0);
    });
  }

  get accounts(): string[] {
    return this._accounts;
  }

  set accounts(accounts: string[]) {
    this._accounts = accounts;
  }

  set loading(value: boolean) {
    setTimeout(() => {
      const nextValue = Math.max(0, this.loadingTriggersCountSubject.getValue() + (value ? 1 : -1));
      this.loadingTriggersCountSubject.next(nextValue);
    });
  }

  public getMyUser(): Observable<User> {
    return this.communicationService.httpGet<Observable<User>>('/users/my-user').pipe(
      catchError((error) => {
          console.error('Error fetching user roles', error);
          throw error;
        }
      ));
  }

  public updateAccountsOnUserUpdate(account: { key: string }, email: string) {
    if (this.authorizationService.hasPermissions([Permissions.READ_ACCOUNT])) {
      this.accounts = Array.from(new Set([
        ...this.accounts,
        ...account.key
      ]));
    } else if (email === this.authorizationService.userProfile.email) {
      this.accounts = [account.key]
    }
  }

  setActiveAccount(org: string): void {
    this.storageService.local.setItem(LocalStorageKeys.ACCOUNT, org);
    this._activeAccount.set(org);
  }
}
